import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {IUser} from '../../models/auth';
import {GenderEnum} from '../../models/user';
import {IPatient} from '../../models/patient';
import {Store} from '@ngxs/store';
import {AppointmentState, AppointmentStatusEnum, AppointmentTypeEnum, IAppointment} from '../../models/appointment';
import {Observable, Subscription} from 'rxjs';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {IClinicalObjective} from '../../models/clinic';
import {StorageService} from '../../services/storage/storage.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  animations: [fadeInAnimation]
})
export class UserInfoComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() patients: IPatient[] = [];
  @Input() clinicalObjectives: IClinicalObjective[];
  @Input() showHeader = true;
  @Input() cardStyles: {};
  @Input() usersCardStyles: {};
  @Input() showEditable = true;
  @Input() showRescheduleButton = true;
  @Input() goal: string;
  @Input() hideHabits: boolean;
  patientSelected: IPatient;
  genderEnum = GenderEnum;
  objective: string;
  appointmentStatusEnum = AppointmentStatusEnum;
  appointmentTypeEnum = AppointmentTypeEnum;
  consultationIsOutOfDate: boolean;
  cardConsultationStyles = {};
  userLogged: IUser;
  appointmentSubscription: Subscription;
  @Output() editButton: EventEmitter<IPatient> = new EventEmitter<IPatient>();
  @Output() rescheduleAppointmentButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelAppointmentButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelGoToConsultationButton: EventEmitter<boolean> = new EventEmitter<boolean>();
   appointment$: Observable<IAppointment> = this.store.select<IAppointment>(AppointmentState.getAppointmentSelected);
  constructor(
    public utilitiesServices: UtilitiesService,
    private store: Store,
    private storageService: StorageService
  ) {
    this.appointmentSubscription = this.appointment$.subscribe(appointment => {
      if (!appointment) return;
      // const isAfterDate = isAfter(new Date(appointment.startDate.date), new Date()); Lo comente porque no se usaba la variable
      if (appointment.status === AppointmentStatusEnum.COMPLETED || appointment.status === AppointmentStatusEnum.CANCELLED) {
        this.consultationIsOutOfDate = true;
      } else {
        this.consultationIsOutOfDate = false;
      }
    });
  }

  /**
   * Se inicializan las propiedades necesarias.
   */
  ngOnInit(): void {
    this.objective = 'Bajar de peso';

    this.cardConsultationStyles = {
      'background-color': '#fff',
      'box-shadow': '0 0 20px 0 rgba(0,0,0,0.06)'
    };

    this.userLogged = this.storageService.getLocalItem<{ token: string, user: IUser }>('user')?.user;
  }

  ngAfterViewInit(): void {
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.patients && this.patients && this.patients.length > 0) {
      this.patientSelected = this.patients[0];
    }
  }

  onEmitEditionMode(): void {
    this.editButton.emit(this.patientSelected);
  }

  /*
  Método no usado
  onSelectPatient(patientId: string): void {
    this.patientSelected = this.patients.find(item => item._id === patientId);
  }
  */

  onEmitRescheduleAppointment(): void {
    this.rescheduleAppointmentButton.emit(true);
  }

  onEmitCancelAppointment(): void {
    this.cancelAppointmentButton.emit(true);
  }

  onEmitGoToConsultation(): void {
    this.cancelGoToConsultationButton.emit(true);
  }

  ngOnDestroy(): void {
    this.appointmentSubscription.unsubscribe();
  }
}
